module.exports = __webpack_public_path__ + "img/btn-armchair@3x.36242d60.png";